export class EmploymentStatus{
  id : number;
  code : string;
  name : string;
  isNotWorking: boolean;
  isQuitJob: boolean;
  isWorking: boolean;
}
